import React, { useEffect, useState } from 'react';
import { Paper, Typography } from '@mui/material';

import styles from './stats.module.scss';
import { useTypedSelector } from '../../../../hooks/useTypesSelector';
import { useActions } from '../../../../hooks/useAction';
import { IDayStatistic, IGameStatistics } from '../../types';
import { getUserId } from '../../../Login/helpers/storage';
import { Loading } from '../../../../ui/loading/Loading';

export const Statistics = () => {
  const { userStats } = useTypedSelector((state) => state.stats);
  const { fetchGetDatStats } = useActions();
  const userID = getUserId() || '';
  const [todayStatistic, setTodayStatistic] = useState<IGameStatistics | null>(null);

  useEffect(() => {
    const day = new Date();
    const date: keyof IDayStatistic = new Intl.DateTimeFormat('en-GB').format(day);
    console.log(date);

    if (!userStats || !userStats.optional[date]) {
      console.log(userID);
      fetchGetDatStats(userID);
      console.log('AAAA');
    } else {
      console.log('BBBB');

      setTodayStatistic(userStats.optional[date]);
    }
  }, [fetchGetDatStats, userID, userStats]);
  if (!todayStatistic) {
    return <Loading />;
  }
  return (
    <>
      <div className={styles.wrapper}>
        <Typography
          variant="h2"
          color="primary"
          textAlign="center"
          sx={{ typography: { sm: 'h4', xs: 'h5', md: 'h3' }, margin: 5 }}
        >
          Статистика за сегодня
        </Typography>
        <Paper elevation={3} sx={{ maxWidth: '60%', minWidth: 300, padding: '20px' }}>
          <div className={styles.general}>
            <div className={styles.general__item}>
              <h3>Изучено слов</h3>
              <span>
                {todayStatistic.audio.learned +
                  todayStatistic.sprint.learned +
                  todayStatistic.textbook}
              </span>
            </div>
            <div className={styles.general__item}>
              <h3>Новых слов</h3>
              <span>{todayStatistic.audio.new + todayStatistic.sprint.new}</span>
            </div>
            <div className={styles.general__item}>
              <h3>Правильных ответов</h3>
              <span>
                {' '}
                {todayStatistic.audio.right +
                  todayStatistic.sprint.right +
                  todayStatistic.sprint.wrong +
                  todayStatistic.audio.wrong ===
                0
                  ? 0
                  : Math.floor(
                      ((todayStatistic.audio.right + todayStatistic.sprint.right) /
                        (todayStatistic.audio.right +
                          todayStatistic.sprint.right +
                          todayStatistic.sprint.wrong +
                          todayStatistic.audio.wrong)) *
                        100
                    )}
                %
              </span>
            </div>
          </div>
        </Paper>
        <div className={styles.stats_game}>
          <Paper elevation={3} sx={{ width: 300, height: 230 }}>
            <h3>Спринт</h3>
            <div className={styles.item__wrapper}>
              <div className={styles.item}>
                <span className={styles.item__number}>{todayStatistic.sprint.new}</span>
                <p>Новых слов</p>
              </div>
              <div className={styles.item}>
                <span className={styles.item__number}>
                  {todayStatistic.sprint.right + todayStatistic.sprint.wrong === 0
                    ? 0
                    : Math.floor(
                        (todayStatistic.sprint.right /
                          (todayStatistic.sprint.right + todayStatistic.sprint.wrong)) *
                          100
                      )}
                  %
                </span>
                <p>Правильных ответов</p>
              </div>
              <div className={styles.item}>
                <span className={styles.item__number}>{todayStatistic.sprint.strike}</span>
                <p>Самая длинная серия правильных ответов</p>
              </div>
            </div>
          </Paper>
          <Paper elevation={3} sx={{ width: 300, height: 230 }}>
            <div className={styles.item__wrapper}>
              <h3>Аудиовызов</h3>
              <div className={styles.item}>
                <span className={styles.item__number}>{todayStatistic.audio.new}</span>
                <p>Новых слов</p>
              </div>
              <div className={styles.item}>
                <span className={styles.item__number}>
                  {todayStatistic.audio.right + todayStatistic.audio.wrong === 0
                    ? 0
                    : Math.floor(
                        (todayStatistic.audio.right /
                          (todayStatistic.audio.right + todayStatistic.audio.wrong)) *
                          100
                      )}
                  %
                </span>
                <p>Правильных ответов</p>
              </div>
              <div className={styles.item}>
                <span className={styles.item__number}>{todayStatistic.audio.strike}</span>
                <p>Самая длинная серия правильных ответов</p>
              </div>
            </div>
          </Paper>
        </div>
      </div>
    </>
  );
};
